/**
 * Note AI Edit API
 *
 * RTK Query mutations for note copy tracking and analytics
 */

import { notesApi } from '@features/notes';

/**
 * Extended notes API with copy tracking endpoints
 */
export const noteAiEditApi = notesApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Set copy status for a note
     * Marks a note as copied (once per note lifetime)
     */
    setCopyStatus: builder.mutation<
      { status: number; message: string },
      { noteId: string }
    >({
      query: ({ noteId }) => ({
        url: '/notes/setCopyStatus',
        method: 'POST',
        body: { note_id: noteId },
      }),
    }),

    /**
     * Record copy event
     * Tracks which module IDs were copied and whether all sections were copied
     */
    recordCopyEvent: builder.mutation<
      { status: number; message: string },
      { noteId: string; moduleIds: string[]; copiedAll: boolean }
    >({
      query: ({ noteId, moduleIds, copiedAll }) => ({
        url: '/notes/recordCopyEvent',
        method: 'POST',
        body: {
          note_id: noteId,
          module_ids: moduleIds,
          copied_all: copiedAll,
        },
      }),
    }),
  }),
});

// Export hooks for mutations
export const { useSetCopyStatusMutation, useRecordCopyEventMutation } = noteAiEditApi;
